import { Component, EventEmitter, HostListener, Input, OnInit, Output, viewChild } from '@angular/core';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { NgClass, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ProductService } from '../../../services/product.service';
import { CommonService } from '../../../services/common.service';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultStyleDirective } from '../../../flex-layout/style';

@Component({
  selector: 'calsoft-search3',
  imports: [DefaultLayoutDirective, DefaultFlexDirective, NgClass, DefaultClassDirective, MatIcon, FormsModule, MatAutocompleteTrigger, NgStyle, DefaultStyleDirective, MatAutocomplete, MatOption],
  templateUrl: './search3.component.html',
  styleUrl: './search3.component.scss'
})
export class Search3Component {
  input!: string;

  @Input() searchbarborderRadius:any="0px";

  search: any;
  page!: number;
  size!: number;
  productName: any;
  filteredOptions: any;
  focused!: boolean;
  @Input() sortParam: string = 'price,DESC';
  empty: any;
  scrollTop!: number;
  @Input() scroll: any=true;
  searchDisabled: boolean=true;
  constructor(
    public productService: ProductService,
    private commonService: CommonService,
    private router:Router,
    
  ) { }

  ngOnInit() {

    this.scrollTop=document.documentElement.scrollTop;

    if(this.router.url=='/cart'||this.router.url=='/checkout/type'||this.router.url=='/checkout'){
      this.searchDisabled=false;
    }
   

  }


  readonly autocomplete = viewChild(MatAutocompleteTrigger);

  filterOption(event:any) {

    if (event.target.value.trim().length > 1) {


      this.search = event.target.value;

        let value1 : any=event.target.value;

        value1= value1.replace(/AND/g, 'asasfas');
        value1= value1.replace(/OR/g, 'bhhasfas');

        let search = "name:" + '*' + value1.trim() + '*'
        + "' OR sku:" + '*' + value1.trim() + '*' + "' "
        + "' OR keyword:" + '*' + value1.trim() + '*' + "' "
      this.page = 0;
      this.size = 10;
      this.sortParam = 'price,DESC';
     
      this.productService.getProductBySearch(search, this.page, this.size, this.sortParam).subscribe(
        (res : any) => {
      if(res!=null){
        this.filteredOptions = res['content'];
        this.empty=res['empty'];
      }else{
        this.filteredOptions = []
        this.empty=true;
      }
        
        })
    }


  }

  onKeydown(event : any) {
    let value1=event.target.value;
 value1= value1.replace(/AND/g, 'asasfas');
  value1= value1.replace(/OR/g, 'bhhasfas');
    if (event.target.value.trim().length > 1) {
      this.saveSearchKeyWords(event.target.value);
      this.commonService.productSearch(value1)
    }
  }
  getProducts(productName : any) {
    productName= productName.replace(/AND/g, 'asasfas');
    productName= productName.replace(/OR/g, 'bhhasfas');
    this.saveSearchKeyWords(productName);
    this.commonService.productSearch(productName)

  }

  openDropdown() {
    this.focused = true;
  }

  closeDropdown() {
    this.focused = false;
  }

  saveSearchKeyWords(i : any) {

    let search = {
      "queryText": i,
      "numResults": 0,
      "popularity": 0,
      "redirect": null,
      "synonymFor": null,
      "storeId": 1,
      "displayInTerms": 1,
      "isActive": 0,
      "isProcessed": 0,
      "operationType": "New"
    }



    this.commonService.saveSearchKeyWords(search).subscribe(
      () => {

      },
      () => { });

  }

    /**
    * On window scroll add class header-fixed.
    */
     @HostListener('window:scroll', ['$event'])
     onScrollEvent() {
     
if(this.scroll){
  if(document.documentElement.scrollTop!=0){{

    this.filteredOptions=[]
    this.search ='';
  }}
 }
}

@Output() callhideSearchBar: EventEmitter<any> = new EventEmitter<any>();

hideSearchBar(){ 
  this.callhideSearchBar.emit(false);
}


}
